import type { FaireProductEntity } from "../../entity_types/product";

export const p_vebchz6vrq: FaireProductEntity = {
  token: "p_vebchz6vrq",
  type: "product",
  name: "Bug Bite Roll-On – Soothing Plant-Based Relief – 10ml",
  brandToken: "b_1e265139",
  brandName: "Woolzies",
  imageUrl:
    "https://cdn.faire.com/fastly/611d77af30c04625755e9b79db0e5e29d7bffbb6d7dbfcf14964168a8985b346.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/82acff173b6cff1b1a8f0a1344a65890018ac6575d84bd6e6b1e386543b1056e.jpeg",
    "https://cdn.faire.com/fastly/cf015d1291f8f39a36e4f72d26c835c3781097df8e875bbbb2430f507eddc4ac.jpeg",
    "https://cdn.faire.com/fastly/5f1da78915f72dde67b6f0c2aace3c616a354e5d0246f6aff79e7f8c744738a2.jpeg",
  ],
  priceDollars: 6.99,
  description:
    "Soothe and calm irritated skin with our Bug Bite Roll-On, a gentle blend of botanicals known for their natural properties. This 10ml roller is perfect for on-the-go relief from outdoor annoyances—just roll on and feel the difference.\n\nKey Benefits:\n\nCooling &amp; Comforting – Formulated with Citronella, Lemon Eucalyptus, Neem, and other plant-based oils to help calm and refresh the skin.\n\nReady to Use – Pre-diluted in nourishing carrier oils like Almond, Coconut, and Sesame for safe application directly to bites or itchy areas.\n\nOutdoor Essential – Keep one in your bag, hiking kit, or picnic basket for nature-ready relief.",
  tags: [],
  msrpDollars: 13.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:49.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
